import { HttpErrorResponse } from '@angular/common/http';

/** Unwraps Wasel API envelope `{ success, data, errors, statusCode }` when present. */
export function unwrapApiData<T>(body: unknown): T | null {
  if (body == null || typeof body !== 'object') {
    return null;
  }
  const o = body as { success?: boolean; data?: unknown };
  if (o.success === false) {
    return null;
  }
  if ('data' in o) {
    return o.data != null ? (o.data as T) : null;
  }
  return body as T;
}

/** When `success === false`, returns the API `errors` string (single message). */
export function readApiEnvelopeError(body: unknown): string | null {
  if (body == null || typeof body !== 'object') {
    return null;
  }
  const o = body as { success?: boolean; errors?: unknown };
  if (o.success !== false) {
    return null;
  }
  const e = o.errors;
  return typeof e === 'string' && e.trim().length > 0 ? e : null;
}

/**
 * The server's own message (`errors`) from a failed HttpClient call that carries the Wasel envelope, or null.
 * Angular's `HttpErrorResponse.message` ("Http failure response for <url>: 0 Unknown Error") is never used: it is
 * English, carries the URL, and means nothing to an operator.
 */
export function readHttpApiErrorMessage(err: HttpErrorResponse): string | null {
  const body = err.error;
  if (!body || typeof body !== 'object') return null;
  const env = readApiEnvelopeError(body);
  if (env) return env;
  const direct = (body as { errors?: unknown }).errors;
  return typeof direct === 'string' && direct.trim().length > 0 ? direct : null;
}
